import ServiceGraphQL from 'src/service/gql-service';
import { getBindVendorDetails } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetBindVendorDetails = (token) => {
  const params = {
    query: getBindVendorDetails.QUERY,
    variables: {
      token,
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
